let language = {
    FOOTER_QPMN_COPYRIGHT: "版权",
    FOOTER_QPMN_MEMBER: "QP集团成员",
    FOOTER_QPMN_TERMS: " 条款与条件",
    FOOTER_QPMN_POLICY: "隐私政策",
    FOOTER_QPSON_COPYRIGHT: "所有内容版权",
    FOOTER_QPSON_COM: ".com (Part of QP Group)",
}

export { language }